/**
 * Structural equality that ignores object key order (jsonb canonicalises it;
 * form state and hydrated rows do not) and treats `undefined` at the root the
 * same as `null`.
 *
 * Shared by the wizard's delta-patch logic (`orgWizardPatch.ts`) and the
 * profile editor's conflict detection (`orgProfileEditorPatch.ts`), which both
 * need the same notion of "did this value actually change" over the same
 * `ProfileData` shape.
 *
 * Pure.
 */
export const canonical = (v: unknown): string =>
  JSON.stringify(v ?? null, (_k, val) =>
    val && typeof val === "object" && !Array.isArray(val)
      ? Object.fromEntries(Object.keys(val).sort().map((k) => [k, (val as Record<string, unknown>)[k]]))
      : val,
  );

export const same = (a: unknown, b: unknown): boolean => canonical(a) === canonical(b);
